export default __webpack_public_path__ + "img/dropdown-down.2e1686b6.svg";